import Pusher, { Channel } from 'pusher-js';

import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PusherService {
  pusher: Pusher;

  /**
   * Constructor of the Service with Dependency Injection
   * @param http The standard Angular HttpClient to make requests
   */
  constructor() {
    if (!environment.production) {
      Pusher.logToConsole = true;
    }
    this.pusher = new Pusher('58cb750d5672b8a78bfc', {
      cluster: 'us3',
      forceTLS: true,
    });
  }

  init(id: number, type_prefix = 'ticket'): Channel {
    return this.pusher.subscribe(`${type_prefix}-${id}`);
  }

  push(id: number, type_prefix = 'ticket', event: string, data): boolean {
    return this.pusher.channel(`${type_prefix}-${id}`).trigger(event, data);
  }

  destroy(id: number, type_prefix = 'ticket'): void {
    return this.pusher.unsubscribe(`${type_prefix}-${id}`);
  }
}
